import { Call } from '@twilio/voice-sdk';
import { useCallback, useEffect, useState } from 'react';

export default function useVoiceAudioToggle(call: Call | null) {
    const [muted, setMuted] = useState(call?.isMuted() ?? true);

    const mute = useCallback(() => {
        call?.mute(true);
    }, [call]);

    const unmute = useCallback(() => {
        call?.mute(false);
    }, [call]);

    const handleMute = useCallback((_muted: boolean) => {
        setMuted(_muted);
    }, []);

    useEffect(() => {
        setMuted(call?.isMuted() ?? true);
        call?.on('mute', handleMute);
        return () => {
            call?.off('mute', handleMute);
        };
    }, [call, handleMute]);

    return { muted, mute, unmute };
}
